import styled from '@emotion/styled';
import '../../../assets/colors.scss';
import { typography } from 'src/theme/typography';
const PricingAndBookingPageStyle = styled('div')`
    background-color: var(--white);
    border: 1px solid var(--sand-400);
    border-radius: 6px;
    padding: 2rem;
    margin-bottom: 2rem;

    .card {
        position: relative;
        margin-bottom: 24px;
        .validTitle {
            ${typography.bodyL}
            color: var(--blue-400);
            border: 1px solid;
            padding: 6px 8px;
            border-radius: 6px;
            display: table;
        }

        .title {
            color: var(--sand-700);
            ${typography.subhead}
            margin: 24px 0;
        }

        &.edit {
            border: 2px solid var(--orange-300);
            padding: 16px;
        }

        .iconAddComment {
            position: absolute;
            right: 0;
            top: 50%;
            margin-right: -25px;
            margin-top: -25px;
            cursor: pointer;
            transition: all 0.2s;
            &:hover {
                transform: scale(1.1);
            }
        }
    }

    .golfLogo {
        max-width: 400px;
        padding: 20px;
        display: table;
        margin: auto;
        img {
            max-width: 100%;
        }
    }

    @media screen and (max-width: 767px) {
        padding: 1rem;
    }
    @media print {
        break-inside: avoid;
        page-break-inside: avoid;
        margin-top: 24px;
    }
`;
export default PricingAndBookingPageStyle;
